import { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "next-i18next";
import Button from "../../../core/Button";
import { postRating } from "../../../../utils/call-api/feedbacks-call";
import { disableFeedbackAvailable } from "../../../../actions/user-actions";

function SwapUserFeedbackRating({
  t,
  closetId,
  setFeedbackId,
  setDisplayCommentModalContent,
  // eslint-disable-next-line no-shadow
  disableFeedbackAvailable,
}) {
  const ratings = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [displayRatingsModalContent, setDisplayRatingsModalContent] = useState(true);
  const [loading, setLoading] = useState(false);

  async function saveRating(rating) {
    if (loading) return;

    try {
      setLoading(true);
      const res = await postRating(rating, closetId);
      disableFeedbackAvailable();
      setFeedbackId(res.data.id);
    } finally {
      setLoading(false);
      setDisplayRatingsModalContent(false);
      setDisplayCommentModalContent(true);
    }
  }

  return (
    <div className={displayRatingsModalContent ? "swap-feedback-content-ratings" : "d-none"}>
      <div className="swap-feedback-title">{t("feedbacks:do_you_like_the_choice_of_clothes")}</div>
      <div className="swap-feedback-ratings">
        {ratings.map((i) => (
          <Button
            key={`feedback-btn-${i}`}
            name="rating"
            size="sm"
            square
            variant="primary"
            onClick={() => saveRating(i)}
            disabled={loading}
          >
            {i}
          </Button>
        ))}
      </div>
      <div className="swap-feedback-captions">
        <p>{t("feedbacks:not_at_all")}</p>
        <p>{t("feedbacks:perfectly")}</p>
      </div>
    </div>
  );
}

export default withTranslation("feedbacks")(
  connect(null, { disableFeedbackAvailable })(SwapUserFeedbackRating),
);
